<template>
  <div class="t-l-body">
    <div class="flex-c" style="padding: 8px;">
      <span style="padding: 0px 8px;">{{$t('cscits1')}}</span>
      <el-date-picker v-model="showDay" @change="showDayChange" type="date" :placeholder="$t('cscits1')">
      </el-date-picker>
    </div>
    <div class="t-l-list">
      <div class="flex-c t-l-time">
        <div style="width: 200px;height: 40px;"></div>
        <div class="time-line-body">
          <div class="flex-c time-line-num">
            <div class="time-line-num-item" v-for="(i,index) in 13" :key="index">
              {{formatting(index)}}
            </div>
          </div>
          <div class="flex-c time-line-point">
            <div class="time-line-point-item" :style="formattingHeight(index)" v-for="(i,index) in 145" :key="index">
            </div>
          </div>
        </div>
      </div>
      <div class="p-list-body">
        <ul class="p-list" :style="{maxHeight: 20*timeHeight+'px'}">
          <li class="flex-c p-item" v-for="(tsItem,index) in timerShaftList" :key="index">
            <el-tooltip class="item" effect="dark" :content="tsItem.name" placement="left">
              <div class="p-name ellipsis-1">{{ tsItem.name }}</div>
            </el-tooltip>

            <div class="p-time flex-c">
              <div class="p-time-line" v-for="(sItem,sindex) in tsItem.schedule" :key="'s'+sindex" :style="{width: (sItem.endTimeStamp-sItem.startTimeStamp)+'px',left: 17+sItem.startTimeStamp+'px'}">
                <div class="p-time-line-t">{{`${sItem.startTime}-${sItem.endTime}`}}</div>
              </div>
              <!-- <div class="p-time-line" :style="{width: (index+1)*10 +'px',left: 17+index*10 +'px'}">
                <div class="p-time-line-t">00:00:00-22:22:22</div>
              </div> -->
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import superClone from '@/assets/scripts/superClone.js'
// reDateFormatting, 
export default {
  name: 'TimerShaft',
  props: {
    timeInfo: {
      type: Array,
      default: () => [],
    },
    timeHeight: {
      type: Number,
      default: 40
    }
  },
  data() {

    return {
      showDay: new Date(),
      timerShaftList: [],
    }
  },
  created() {
    // console.log(this.timeInfo);
    this.timerShaftList = this.getDayTimerShaft(this.showDay);

  },
  mounted() {
    // const tsNode = document.getElementsByClassName('t-l-body')[0];
    // console.log(tsNode.offsetHeight);
    // console.log(tsNode.offsetWidth);
  },
  watch: {
    timeInfo: {
      handler() {
        // console.log(nVal);
        this.timerShaftList = this.getDayTimerShaft(this.showDay);
      }
    }
  },
  methods: {
    getDayTimerShaft(showDay) {
      // console.log(this.timeInfo);
      let timerShaftList = superClone(this.timeInfo);
      const stamp00 = new Date(showDay.setHours(0, 0, 0, 0)).getTime(); //获取当天零点的时间
      // const stamp24 = new Date(showDay.setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1).getTime(); //获取当天23:59:59的时间
      timerShaftList = timerShaftList.filter((t) => {
        t.schedule = t.schedule.filter(s => {
          const { dateStart, dateEnd } = s;
          if (!dateStart || !dateEnd) { return true; }
          const st = new Date(dateStart.setHours(0, 0, 0, 0)).getTime();
          const et = new Date(dateEnd.setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1).getTime();
          return stamp00 >= st && stamp00 <= et;
        });
        t.schedule = t.schedule.map((s) => {
          const { startTime, endTime } = s;
          s = { ...s, endTimeStamp: (this.reTimeFormatting(endTime, showDay).getTime() - stamp00) / 1000 / 60 * 0.4, startTimeStamp: (this.reTimeFormatting(startTime, showDay).getTime() - stamp00) / 1000 / 60 * 0.4 };
          return s;
        });
        return t.schedule.length > 0;
      });
      // console.log(timerShaftList);
      return timerShaftList;
    },
    showDayChange(val) {
      this.showDay = val;
      this.timerShaftList = this.getDayTimerShaft(val);
    },
    formatting(val) {
      return val < 5 ? `0${val * 2}:00` : (val * 2 + ':00');
    },
    formattingHeight(val) {
      let h = val % 12 === 0 ? 40 : val % 6 === 0 ? 16 : 8;
      if (val === 132) {
        h = 40;
      }
      return { height: h + 'px' }
    },
    // formattingTimeLine(val) {
    //   let h = val % 12 === 0 ? 40 : val % 6 === 0 ? 16 : 8;
    //   if (val === 132) {
    //     h = 40;
    //   }
    //   return { left: h + 'px', width: h + 'px' }
    // },
    reTimeFormatting(strTime, date = new Date()) {
      strTime = this.dateFormatting(date, '-') + ' ' + strTime;
      let time = new Date(Date.parse(strTime.replace(/-/g, "/")));
      // console.log(time);
      return time;
    },
    dateFormatting(date, cut = '/') {
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      let D = date.getDate();
      return `${Y}${cut}${M < 10 ? '0' + M : M}${cut}${D < 10 ? '0' + D : D}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.t-l-body {
  --time-height: 40px;
  width: 100%;
  height: 100%;
  min-width: 820px;
  overflow-x: auto;
  overflow-y: auto;
  .t-l-list {
    overflow: hidden;
    border-top: 1px solid #dcdfe6;
    height: calc(100% - 60px);
    .t-l-time {
      border-bottom: 1px solid #dcdfe6;
      .time-line-body {
        width: calc(100% - 200px);
        height: 40px;
        border-left: 1px solid #dcdfe6;
        line-height: 40px;
        position: relative;
        .time-line-num {
          position: absolute;
          left: 0;
          .time-line-num-item {
            transform: rotate(-90deg);
            font-size: 12px;
            width: 44px;
            padding-right: 4px;
            height: 40px;
            text-align: right;
          }
        }
        .time-line-point {
          height: 40px;
          position: absolute;
          left: 14px;
          align-items: flex-end;
          .time-line-point-item {
            box-sizing: border-box;
            width: 4px;
            border-right: 1px solid #000;
          }
        }
      }
    }
    .p-list-body {
      height: calc(100% - 40px);
      overflow-x: hidden;
      overflow-y: auto;
    }
    .p-list {
      overflow: hidden;
      // height: calc(100% - 40px);
      // overflow-x: hidden;
      // overflow-y: auto;
      .p-item {
        height: 40px;
        .p-name {
          width: 200px;
          height: 100%;
          line-height: 40px;
          text-align: right;
          padding-right: 8px;
          box-sizing: border-box;
          cursor: pointer;
        }
        .p-name:hover{
          background-color: #edfbff;
        }
        .p-time {
          width: calc(100% - 200px - 17px);
          height: 100%;
          line-height: 40px;
          border-left: 1px solid #dcdfe6;
          padding-left: 17px;
          position: relative;
          .p-time-line {
            height: 28px;
            // 4个像素每10分钟,每分钟0.4个像素
            width: 576px;
            background-color: #409eff;
            position: absolute;
            .p-time-line-t {
              position: absolute;
              width: 200px;
              height: 28px;
              line-height: 28px;
              display: none;
              cursor: pointer;
            }
          }
          .p-time-line:hover::before {
            content: "";
            position: absolute;
            left: 0px;
            top: -5000px;
            border-left: 1px dashed #409eff;
            height: 10000px;
          }
          .p-time-line:hover::after {
            content: "";
            position: absolute;
            right: -1px;
            top: -5000px;
            border-left: 1px dashed #409eff;
            height: 10000px;
          }
          .p-time-line:hover .p-time-line-t {
            display: block;
          }
        }
      }
    }
  }
}
</style>